<template>
  <div class="building-template">
    <label :class="{ 'required-flag': isEditing, bold: true }">{{ $t('name') }}</label>
    <TextField
      :showColon="false"
      :readonly="!isEditing"
      label=""
      :value="templateDetail.title"
      @updateValue="val => updateTemplateTitle(val)"
      :required="true"
    />
    <upload-photo-area
      :uploadSuccess="uploadSuccess"
      :photoesInfo="templateList"
      :selectEditPhotoInfo="selectEditPhotoInfo"
      :isEditing="isEditing"
      :allowEdit="allowEdit"
      :updatePhotoInfo="updatePhotoInfo"
      :deleteOnePhoto="deleteOnePhoto"
      :beforeUpload="beforeUpload"
      :deleteOnePhotoInfo="deleteOnePhotoInfo"
      :onDragEnd="dragEnd"
      :action="ActionTypes.settings.doc.hotbTemplate.create"
      :additionalInfo="{buildingId}"
    />
    <div
      v-if="!templateList.length && !isEditing"
      class="empty-tips"
    >
      <p>{{ $t('setting.engineers.buildingTemplate.editMessage') }}</p>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'

import UploadPhotoArea from '@/controls/UploadPhotoArea'
import TextField from '@/controls/TextField'

import notification from '@/utils/notification'
import { ActionTypes, templateChip } from '@/utils/consts'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import { getKey } from '@/api/common/request'
import { updateBuildingTemplateDetail, getBuildingTemplateDetail, createOneBuildingTemplate } from '@/api/buildings/request'
import { utils as formUtils } from '@/plugin/InputChange'

export default {
  name: 'BuildingTemplate',
  components: {
    UploadPhotoArea,
    TextField,
  },
  props: {
    allowEdit: {
      type: Boolean,
      default: true,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      ActionTypes,
      templateList: [],
      editIndex: -1,
      buildingId: '',
      templateDetail: {},
      templateDesc: '',
    }
  },
  methods: {
    uploadSuccess (files) {
      if (files.length) {
        const list = lodash.cloneDeep(this.templateList)
        list[this.editIndex].files.push(files[0])
        this.templateList = list
        this.refreshView()
      }
    },
    selectEditPhotoInfo (item, index) {
      if (this.isEditing && this.allowEdit) {
        this.editIndex = index
      }
    },
    updatePhotoInfo (path, index, val) {
      lodash.set(this.templateList[index], path, val)
      this.refreshView()
    },
    deleteOnePhoto (photo, editItem, editIndex) {
      this.editIndex = editIndex
      const index = lodash.findIndex(this.templateList[this.editIndex].files, file => file.id === photo.id)
      const list = lodash.cloneDeep(this.templateList)
      if (index !== -1) {
        list[this.editIndex].files.splice(index, 1)
        this.templateList = list
      }
      this.refreshView()
    },
    beforeUpload (xhr, file) {
      let isNotUploadedFile = true
      this.templateList[this.editIndex].files.map(item => {
        const itemFilename = item.filename.split('|NAME|')[1]
        if (itemFilename === file.name) {
          isNotUploadedFile = false
        }
      })
      if (!isNotUploadedFile) {
        notification.fireNotification(false, `File ${file.name} upload error: duplicate file name`)
      }
      return isNotUploadedFile
    },
    deleteOnePhotoInfo (index) {
      this.templateList.splice(index, 1)
      this.refreshView()
    },
    async addOneTemplateChip () {
      const id = await getKey()
      this.templateList.push(lodash.set(lodash.cloneDeep(templateChip), 'id', id))
      this.refreshView()
      setTimeout(function () {
        window.scrollTo(0, document.body.clientHeight)
      }, 0)
    },
    async cancel () {
      this.templateDetail = await getBuildingTemplateDetail(this.buildingId, this.tid) || []
      this.templateList = lodash.cloneDeep(this.templateDetail['items'])
      formUtils.resetDirty()
    },
    validate () {
      fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, '.building-template')
      return $('.building-template input.is-invalid-input').length === 0 &&
        fusionInputCheckUtil.isAllFieldsValid('.building-template')
    },
    resetValidation () {
      fusionInputCheckUtil.resetAllFields()
    },
    dragEnd (list) {
      this.templateList = list
    },
    refreshView () {
      this.$set(this.templateDetail, 'items', lodash.cloneDeep(this.templateList))
      this.$forceUpdate()
    },
    async save () {
      const ret = this.validate()
      if (ret) {
        this.templateDetail.items = this.templateList
        formUtils.resetDirty()
        if (this.tid === 'createTemplate') {
          this.templateDetail = await createOneBuildingTemplate(this.buildingId, this.templateDetail)
          this.templateList = this.templateDetail['items']
          // Reset tid from createTemplate to template id when create successfully
          this.tid = this.templateDetail.id
          this.$router.replace({
            name: 'building-detail',
            params: {
              id: this.buildingId,
              tid: this.templateDetail.id,
            },
          })
        } else {
          this.templateDetail = await updateBuildingTemplateDetail(this.buildingId, this.tid, this.templateDetail)
          this.templateList = this.templateDetail['items']
        }
      }
      return ret
    },
    updateTemplateTitle (val) {
      this.templateDetail.title = val
    },
  },
  async mounted () {
    this.buildingId = this.$router.currentRoute.params.id
    this.tid = this.$router.currentRoute.params.tid
    const id = await getKey()
    if (this.tid === 'createTemplate') {
      this.templateList.push(lodash.cloneDeep(Object.assign(templateChip, {id})))
    } else {
      this.templateDetail = await getBuildingTemplateDetail(this.buildingId, this.tid)
      this.templateList = this.templateDetail['items'] ? this.templateDetail['items'] : []
    }
  },
}
</script>

<style lang="scss">
.building-template {
  .btns {
    font-size: 0;
    text-align: right;
    button {
      margin-right: 15px;
    }
  }
  .bold {
    font-weight: bold;
  }
  .upload-photo-area .inputGroupItem .delete {
    right: -20px;
  }
  .empty-tips {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    margin-top: 40px;
  }
}
</style>
